var map = {
	"./events-cat-cn.webp": 2005,
	"./events-cat.webp": 2006,
	"./games-cat.webp": 2007,
	"./live-casino-cat-cn.webp": 2008,
	"./live-casino-cat.webp": 2009,
	"./lottery-cat.webp": 2010,
	"./other-cat.webp": 2011,
	"./p2p-cat.webp": 2012,
	"./pd-table.webp": 2013,
	"./privacy-policy-title-bm.webp": 2014,
	"./privacy-policy-title-cn.webp": 2015,
	"./privacy-policy-title-id.webp": 2016,
	"./privacy-policy-title.webp": 2017,
	"./promos-1.webp": 2018,
	"./promos-2.webp": 2019,
	"./promos-3.webp": 2020,
	"./promos-4.webp": 2021,
	"./question.webp": 2022,
	"./sideBar-bg.webp": 2023,
	"./slot-cat-cn.webp": 2024,
	"./slot-cat.webp": 2025,
	"./special-cat-cn.webp": 2026,
	"./special-cat.webp": 2027,
	"./sports-cat-cn.webp": 2028,
	"./sports-cat.webp": 2029
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;